import React from "react";

const unbounceContainerElementClassName = "ub-emb-container";

/**
 * Reports whether an Unbounce promo banner is currently in the DOM.
 *
 * The banner is portaled to `<body>` as a `.ub-emb-container` element (both the
 * real Unbounce embed and the dev test banner). Detection is reactive: it
 * checks on mount for a banner already present, and observes `<body>`'s direct
 * children so it also updates when a banner is added or removed at runtime
 * (e.g. toggled from DevTools, or a late-loading embed). Watching only body's
 * childList keeps this cheap.
 */
export function useHasUnbounceBar() {
	const [hasUnbounceBar, setHasUnbounceBar] = React.useState(false);

	React.useEffect(() => {
		const check = () => {
			const container = document?.getElementsByClassName(
				unbounceContainerElementClassName,
			)?.[0];
			const targetNode = container?.children?.item(0);
			setHasUnbounceBar((targetNode?.children.length ?? 0) > 0);
		};

		check();

		const observer = new MutationObserver(check);
		observer.observe(document.body, { childList: true });
		return () => observer.disconnect();
	}, []);

	return hasUnbounceBar;
}
